import { render, staticRenderFns } from "./tableCell.vue?vue&type=template&id=3df1539b&"
import script from "./tableCell.vue?vue&type=script&lang=js&"
export * from "./tableCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/layout/tableCell.vue"
export default component.exports